import { initializeVue } from "@/core/app-setup";
import PipedValue from "@/experiences/piping/views/PipedValue.vue";
window.initializePipedValue = (elSelector, rootProps) => {
    rootProps = { ...rootProps, element: elSelector };
    return initializeVue(elSelector, PipedValue, { rootProps, remountable: true, includeDestroyFn: true });
};
